<footer class="border-t border-neutral-3 bg-neutral-1 text-neutral-11 mt-auto">
  <div class="mx-auto px-6 sm:px-10 py-10 lg:py-14" [class]="maxWidthClass()">
    @if (hasUpperSection()) {
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 pb-10 border-b border-neutral-3">
        <!-- Brand & Description Column -->
        <div class="sm:col-span-2 lg:col-span-4 flex flex-col gap-4 pr-0 lg:pr-6">
          <a [routerLink]="homeRoute()" class="inline-flex items-center gap-2.5 w-fit select-none">
            @if (logoUrl()) {
              <img class="size-7" [src]="logoUrl()" [alt]="companyName()" />
            }
            @if (companyName()) {
              <span class="text-xl font-extrabold tracking-tight text-neutral-12">{{ companyName() }}</span>
            }
          </a>

          @if (description(); as desc) {
            <p class="text-xs sm:text-sm text-neutral-10 leading-relaxed">
              {{ desc }}
            </p>
          }

          @if (badge(); as badgeInfo) {
            <div
              class="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-neutral-2 border border-neutral-3 text-xs font-medium text-neutral-11 w-fit"
            >
              @if (badgeInfo.icon; as iconName) {
                <div
                  class="flex items-center justify-center size-5 rounded-md bg-jade-a3 text-jade-11 shrink-0"
                >
                  <mat-icon [svgIcon]="iconName" class="w-3.5! h-3.5! flex!" />
                </div>
              }
              <span>{{ badgeInfo.text }}</span>
            </div>
          }
        </div>

        <!-- Dynamic Navigation Columns -->
        @for (col of columns(); track col.title) {
          <div class="lg:col-span-2 flex flex-col gap-3">
            <h3 class="text-xs font-bold tracking-wide text-neutral-12">{{ col.title }}</h3>
            <ul class="flex flex-col gap-2.5 text-xs sm:text-sm text-neutral-10">
              @for (link of col.links; track link.label) {
                <li>
                  @if (link.href) {
                    <a [href]="link.href" class="hover:text-neutral-12 hover:underline transition-colors">
                      {{ link.label }}
                    </a>
                  } @else if (link.routerLink) {
                    <a
                      [routerLink]="link.routerLink"
                      [queryParams]="link.queryParams"
                      class="hover:text-neutral-12 hover:underline transition-colors"
                    >
                      {{ link.label }}
                    </a>
                  }
                </li>
              }
            </ul>
          </div>
        }
      </div>
    }

    <!-- Bottom Legal & Localization Bar -->
    <div
      class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-neutral-10"
      [class.pt-6]="hasUpperSection()"
    >
      <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
        <span class="font-medium text-neutral-11">© {{ currentYear() }} {{ companyName() }}</span>
        <span aria-hidden="true">·</span>
        <a [routerLink]="mentionsRoute()" class="hover:text-neutral-12 hover:underline transition-colors">
          Mentions légales
        </a>
        <span aria-hidden="true">·</span>
        <a [routerLink]="privacyRoute()" class="hover:text-neutral-12 hover:underline transition-colors">
          Politique de confidentialité
        </a>
        <span aria-hidden="true">·</span>
        <a [routerLink]="cguRoute()" class="hover:text-neutral-12 hover:underline transition-colors">
          Conditions générales d’utilisation
        </a>
        @if (showCookiesTrigger()) {
          <span aria-hidden="true">·</span>
          <button
            type="button"
            (click)="onOpenCookies()"
            class="hover:text-neutral-12 hover:underline transition-colors cursor-pointer bg-transparent border-0 p-0 text-xs text-neutral-10 font-normal"
          >
            Gestion des cookies
          </button>
        }
      </div>

      <div class="flex flex-wrap items-center gap-3 text-xs font-medium text-neutral-11">
        @if (localeLabel(); as loc) {
          <span>{{ loc }}</span>
          <span aria-hidden="true" class="text-neutral-6">·</span>
        }
        <span>{{ languageLabel() }}</span>
        @if (currencyLabel(); as curr) {
          <span aria-hidden="true" class="text-neutral-6">·</span>
          <span>{{ curr }}</span>
        }
      </div>
    </div>
  </div>
</footer>
